export const PulseDot = () => (
  <span
    aria-label="In progress"
    role="status"
    className="ml-1 inline-block size-2 animate-pulse rounded-full bg-foreground align-middle"
  />
);
